module.exports = __webpack_public_path__ + "img/icon_wykl.315efc81.png";